import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components/macro';

import { fontDefaultAlt } from '@mirinae/react-ui';

import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { FormattedText } from '@mirinae/lessons/components/lesson/elements/Text';
import IconLightbulb from '@mirinae/lessons/components/lesson/icons/IconLightbulb';
import { LessonButton } from '@mirinae/lessons/modules/defines/styles';
import { lessonsPalette, zIndex } from '@mirinae/lessons/modules/defines/styles';
import Localization from '@mirinae/shared/il8n';

const HintElement = styled(Element)`
    position: relative;
    z-index: ${zIndex.hint};
    visibility: ${props => (props.visible ? 'visible' : 'hidden')};
`;

const Button = styled(LessonButton)`
    height: 25px;
    padding: 5px 15px;
    border-radius: 15px;
    font-size: 12px;
    font-weight: 700;
    font-family: ${fontDefaultAlt};
    color: ${lessonsPalette.darken[0]};
    background-color: ${lessonsPalette.light[0]};
    white-space: nowrap;
    svg {
        vertical-align: middle;
        margin-right: 5px;
    }
    ${props => (props.active && `
        color: ${lessonsPalette.primary.white};
        background-color: ${lessonsPalette.darken[0]};
        svg path {
            fill: ${lessonsPalette.primary.white};
        }
    `)}
`;

const FormattedTextWrap = styled.div`
    z-index: ${zIndex.hint};
    position: absolute;
    left: ${props => `${props.x}px`};
    top: 35px;
    transform: translateX(calc(-50% - 8px));
    min-width: 310px;
    padding: 10px 15px;
    border: 1px solid ${lessonsPalette.darken[0]};
    border-radius: 10px;
    color: ${lessonsPalette.primary.black};
    font-size: 12px;
    background-color: ${lessonsPalette.primary.white};
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.11));
  
    &:before {
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        top: -7px;
        width: 11px;
        height: 11px;
        border: solid ${lessonsPalette.darken[1]};
        border-width: 1px 1px 0 0;
        background-color: ${lessonsPalette.primary.white};
        transform: rotate(-45deg);
    }
`;

const HintButton = ({ element }) => {
    const $button = useRef(null);
    const [showHint, setShowHint] = useState(false);
    const [dist, setDist] = useState(0);

    const text = element.fieldsByName.text;

    const handleCloseLayer = (e) => {
        if (e.target.type === 'button') return;
        setShowHint(false);
    };

    useEffect(() => {
        document.body.addEventListener('click', handleCloseLayer, false);
        return () => {
            document.body.removeEventListener('click', handleCloseLayer);
        };
    }, []);
    useEffect(() => {
        setDist($button.current.offsetWidth * 0.5);
    }, [showHint]);

    return (
        <HintElement element={element} visible={Boolean(text.value)}>
            <Button ref={$button} data-t="lesson-hint-btn" type="button" onClick={() => setShowHint(!showHint)} active={showHint}><IconLightbulb />{Localization['player-hint']}</Button>
            { showHint && (
                <FormattedTextWrap x={dist}>
                    <FormattedText text={text.value} styles={text.styles} links={text.links} />
                </FormattedTextWrap>
            )}
        </HintElement>
    );
};

export default HintButton;
